import React from 'react';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import PropTypes from 'prop-types';
import styles from './index.css';
import '../reset.css';

import Header from '../../components/header/';
import Navigation from '../../components/navigation/';
import Footer from '../../components/footer/';
import PerIntroWithAnchor from './perIntroWithAnchor/';
import { getImage } from '@ifeng-fe/container_channel/common/client/spring/utils/cutImg';
import {
    instituteConsultantData,
    instituteScienceData,
    instituteSeniorFeData,
    instituteInvitedFeData,
    instituteEconomistData,
} from '../../../../services/api';

class Layout extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    constructor(props) {
        super(props);

        this.state = {
            consultant: [],
            science: [],
            seniorFe: [],
            invitedFe: [],
            economist: [],
        };
    }

    async componentDidMount() {
        this.getConsultantData();
        this.getScienceData();
        this.getSeniorFeData();
        this.getInvitedFeData();
        this.getEconomistData();
    }
    /**
     * 获取顾问数据
     */
    getConsultantData = async () => {
        const conData = await instituteConsultantData();
        const conDataF = [];

        conData.msg =
            conData.msg.length > 0
                ? conData.msg.map(item => {
                      item.feng_url = `//feng.ifeng.com/author/${item.zmt_id}`;
                      item.image = getImage(item.image, 240, 145);
                      conDataF.push(item);

                      return '';
                  })
                : [];
        // console.log('con==', conDataF);
        this.setState({
            consultant: conDataF,
        });
    };
    /**
     * 获取学术委员会数据
     */
    getScienceData = async () => {
        const scienceData = await instituteScienceData();

        this.setState({
            science: this.handleScience(scienceData.msg),
        });
        // console.log('sc===', this.state.science);
    };
    /**
     * 获取高级研究院数据
     */
    getSeniorFeData = async () => {
        const seniorFeData = await instituteSeniorFeData();

        this.setState({
            seniorFe: this.handleScience(seniorFeData.msg),
        });
        // console.log('sc2===', this.state.seniorFe);
    };
    /**
     * 获取特邀研究院数据
     */
    getInvitedFeData = async () => {
        const invitedFeData = await instituteInvitedFeData();

        this.setState({
            invitedFe: this.handleScience(invitedFeData.msg),
        });
        // console.log('sc3===', this.state.invitedFe);
    };
    /**
     * 获取特约经济学家数据
     */
    getEconomistData = async () => {
        const economistData = await instituteEconomistData();

        this.setState({
            economist: this.handleScience(economistData.msg),
        });
        // console.log('sc4===', this.state.economist);
    };

    getUpperAleph = name => {
        // 获取字符串的首字母并将其大写
        let fN = name.charAt(0);

        fN = fN.toUpperCase();

        return fN;
    };

    handleScience = data => {
        // console.log('handleScience');
        const dataA = [];
        const dataG = [];
        const dataM = [];
        const dataU = [];
        let enName = '';
        let zmt_id = '';
        let url = '';
        let dataF = [];

        if (data.map) {
            data.map(item => {
                enName = this.getUpperAleph(item.spell);

                zmt_id = item.zmt_id;
                url = `//feng.ifeng.com/author/${zmt_id}`;

                item.feng_url = url;
                item.image = getImage(item.image, 240, 145);
                if (enName >= 'A' && enName <= 'F') {
                    dataA.push(item);
                }
                if (enName >= 'G' && enName <= 'L') {
                    dataG.push(item);
                }
                if (enName >= 'M' && enName <= 'T') {
                    dataM.push(item);
                }
                if (enName >= 'U' && enName <= 'Z') {
                    dataU.push(item);
                }

                return dataA;
            });
        }
        dataF = [{ A: dataA }, { G: dataG }, { M: dataM }, { U: dataU }];

        return dataF;
    };
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const {
            header,
            navigation,
            footer,
            adviser,
            academic,
            seniorReasearcher,
            invitateReasearcher,
            contractEconomist,
        } = content;
        const { consultant, science, seniorFe, invitedFe, economist } = this.state;

        return (
            <div>
                <Header content={header} />
                <Navigation content={navigation} current={2} />
                <div className={styles.academicP}>
                    <PerIntroWithAnchor title="顾问" id="adviser" content={consultant} />

                    <PerIntroWithAnchor title="学术委员会" id="committee" rank content={science} />

                    <PerIntroWithAnchor title="高级研究员" id="seniorReasearcher" rank content={seniorFe} />

                    <PerIntroWithAnchor title="特邀研究员" id="invitateReasearcher" rank content={invitedFe} />

                    <PerIntroWithAnchor title="特约经济学家" id="contractEconomist" rank content={economist} />
                </div>
                <Footer content={footer} />
                <ChipEdit />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Layout.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Layout.defaultProps = {};

export default Layout;
